import { EmptyValue } from '@/components/custom/empty-value'
import { HighlightedText } from '@/components/custom/highlighted-text'
import { createMemoCell } from '@/lib/create-memo-cell'
import { formatUrlForDisplay, normalizeUrl } from '@/lib/url'

interface CellExternalLinkProps {
  value: string | null | undefined
  searchTerm?: string
}

function CellExternalLinkBase({ value, searchTerm }: CellExternalLinkProps) {
  if (value === null || value === undefined || value === '') {
    return <EmptyValue />
  }

  const displayValue = formatUrlForDisplay(value)
  const href = normalizeUrl(value)

  const displayContent = searchTerm ? (
    <HighlightedText text={displayValue} highlight={searchTerm} />
  ) : (
    displayValue
  )

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      onClick={(e) => e.stopPropagation()}
      className="hover:underline truncate block"
    >
      {displayContent}
    </a>
  )
}

export const CellExternalLink = createMemoCell(
  CellExternalLinkBase,
  'CellExternalLink'
)
export type { CellExternalLinkProps }
